module.exports = __webpack_public_path__ + "static/media/linkedin.9300932b.svg";